import { addTagsToInventoryItem, getTags } from '@services/queries/tags';
import {
  useInfiniteQuery,
  UseInfiniteQueryResult,
  useMutation,
} from 'react-query';

import { IPaginationResult } from '@models/Equipment.model';
import { ITag } from '@models/Tag.model';

export function useAssignTagMutation() {
  return useMutation(addTagsToInventoryItem, {
    onSuccess: () => {
      // Do nothing. This is set outside
    },
  });
}

export function useSearchFilteredTags(
  searchText: string,
  tagCategoryId: string,
): UseInfiniteQueryResult<IPaginationResult<ITag>> {
  return useInfiniteQuery(
    ['tagCategories', tagCategoryId, 'tags', searchText],
    async ({ pageParam = 1 }) => {
      const Tag = await getTags({
        pagination: {
          page: pageParam,
          limit: 20,
          search: searchText,
        },
        filter: { tagCategoryId },
      });
      return Tag;
    },
    {
      getPreviousPageParam: undefined,
      getNextPageParam: lastPage =>
        lastPage.hasMore ? lastPage.currentPage + 1 : undefined,
    },
  );
}
